const PREFERRED_BOOKING_URL_KEYS = [ "default", "web", "ios", "android", "app" ] as const;

/**
 * Returns true when `value` is a non-empty string after trimming.
 */
export const isNonEmptyText = ( value: unknown ): value is string => {
    return typeof value === "string" && value.trim().length > 0;
};

/**
 * Resolves a booking URL from a provider `bookingUrls` payload.
 *
 * @remarks
 * The function first checks preferred keys and then falls back to the first non-empty value.
 */
export const resolveBookingUrlFromBookingUrls = ( bookingUrls: string | Record<string, string> ): string | null => {
    if ( isNonEmptyText( bookingUrls ) ) {
        return bookingUrls;
    }

    for ( const key of PREFERRED_BOOKING_URL_KEYS ) {
        const candidate = bookingUrls[key];
        if ( isNonEmptyText( candidate ) ) {
            return candidate;
        }
    }

    for ( const candidate of Object.values( bookingUrls ) ) {
        if ( isNonEmptyText( candidate ) ) {
            return candidate;
        }
    }

    return null;
};
